import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ControlledVocab } from '@folio/stripes/smart-components';
import { withStripes } from '@folio/stripes/core';

class ReportTypesSettings extends React.Component {
  static propTypes = {
    stripes: PropTypes.shape({
      connect: PropTypes.func.isRequired,
    }).isRequired,
    intl: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.connectedControlledVocab = props.stripes.connect(ControlledVocab);
  }

  render() {
    const { stripes, intl } = this.props;
    const canManage = stripes.hasPerm('ui-reports.report-types.manage');

    return (
      <this.connectedControlledVocab
        stripes={stripes}
        baseUrl="report-types"
        records="reportTypes"
        label={intl.formatMessage({
          id: 'ui-reports.settings.reportTypes.label',
          defaultMessage: 'Report Types',
        })}
        objectLabel={
          <FormattedMessage
            id="ui-reports.settings.reportTypes.label"
            defaultMessage="Report Types"
          />
        }
        visibleFields={['name']}
        hiddenFields={['numberOfObjects']}
        columnMapping={{
          name: intl.formatMessage({
            id: 'ui-reports.settings.reportTypes.name',
            defaultMessage: 'Name',
          }),
        }}
        nameKey="name"
        sortby="name"
        canCreate={canManage}
        actionSuppressor={{
          edit: () => !canManage,
          delete: () => !canManage,
        }}
      />
    );
  }
}

export default injectIntl(withStripes(ReportTypesSettings));
